import { useState, useCallback, useRef } from 'react';

const CACHE_DURATION = 5 * 60 * 1000;

export const useDataCache = () => {
  const cacheRef = useRef(new Map());
  const timestampsRef = useRef(new Map());

  const getCached = useCallback((key) => {
    const timestamp = timestampsRef.current.get(key);
    if (timestamp && Date.now() - timestamp < CACHE_DURATION) {
      return cacheRef.current.get(key);
    }
    return null;
  }, []);

  const setCached = useCallback((key, data) => {
    cacheRef.current.set(key, data);
    timestampsRef.current.set(key, Date.now());
  }, []);

  const invalidateCache = useCallback((key) => {
    cacheRef.current.delete(key);
    timestampsRef.current.delete(key);
  }, []);

  const invalidateAll = useCallback(() => {
    cacheRef.current.clear();
    timestampsRef.current.clear();
  }, []);

  return { getCached, setCached, invalidateCache, invalidateAll };
};